import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faDownload, faUsers, faPenToSquare, faCalendar, faClock, faLocationDot, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';
import moment from 'moment';
import { NumericFormat, PatternFormat } from 'react-number-format';
import useApiFetch from '../../ApiFetch';
import { HtmlEditor } from '../shared/htmlEditor';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TimeFromDate from '../shared/TimeFromDate';
import DownloadCSV from '../shared/DownloadCSV';
import { CSVLink, CSVDownload } from "react-csv";

export default function EventSettings(props) {
    const { eventData, updatedData } = props;
    const apiFetch = useApiFetch();

    const [modal, setModal] = useState(false);
    const [showCodeError, setShowCodeError] = useState(false);

    const canClose = !(eventData.requiresRegistrationCode && !eventData.registrationCode);

    const handleModalToggle = () => {
        if (canClose) {
            setShowCodeError(false);
            setModal(!modal);
        } else {
            setShowCodeError(true);
        }
    };

    useEffect(() => {
        //setLoading(true);
    }, []);

    const updateEventData = async (newData) => {
        if (updatedData)
            updatedData(newData);
    }

    return (
        <>
            <FontAwesomeIcon icon={faGear} title='Event Settings' className='text-primary lh-1 px-1' size="lg" style={{ cursor: 'pointer' }} onClick={handleModalToggle} />
            <Modal isOpen={modal} toggle={handleModalToggle} size="sm" fade={true} backdrop={canClose ? true : 'static'} keyboard={canClose}>
                <ModalHeader toggle={handleModalToggle}>
                    <FontAwesomeIcon icon={faGear} className="pe-2" />Event Settings
                </ModalHeader>
                <ModalBody className="table-responsive" style={{ display: 'block', width: '100%', overflowX: 'auto', maxHeight: 'calc(-124px + 100vh)' }}>
                    <div className="row g-3 align-items-center">
                        <div className="col-auto">
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" role="switch" id="chkAllowsGuests" value={eventData.supportsGuests} checked={eventData.supportsGuests} onChange={() => updateEventData({ ...eventData, supportsGuests: !eventData.supportsGuests })} />
                                <label className="form-check-label" htmlFor="chkAllowsGuests">Allows Guests</label>
                            </div>
                        </div>

                        <>
                            <div className="col-auto">
                                <input
                                    type="number"
                                    className="form-control form-control-sm text-end px-0"
                                    id="maxGuests"
                                    value={eventData.maxGuestsAllowed ?? ''}
                                    onChange={(e) => updateEventData({ ...eventData, maxGuestsAllowed: e.target.value === '' ? null : Number(e.target.value) })}
                                    min="0"
                                    max="100"
                                    step="1"
                                    disabled={!eventData.supportsGuests}
                                    style={{ maxWidth: '2.5rem' }}
                                />
                            </div>
                        </>
                    </div>
                    <hr />
                    <div className="row g-3 align-items-center">
                        <div className="col-auto">
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" role="switch" id="chkRequiresRegistrationCode" checked={eventData.requiresRegistrationCode ?? false} onChange={() => { setShowCodeError(false); updateEventData({ ...eventData, requiresRegistrationCode: !eventData.requiresRegistrationCode }); }} />
                                <label className="form-check-label" htmlFor="chkRequiresRegistrationCode">Require Registration Code</label>
                            </div>
                        </div>
                        <div className="col-12">
                            <input
                                type="text"
                                className={`form-control form-control-sm text-uppercase${showCodeError ? ' is-invalid' : ''}`}
                                id="registrationCode"
                                placeholder="Enter code"
                                value={eventData.registrationCode ?? ''}
                                onChange={(e) => { setShowCodeError(false); updateEventData({ ...eventData, registrationCode: e.target.value }); }}
                                maxLength="50"
                                disabled={!eventData.requiresRegistrationCode}
                            />
                            {eventData.requiresRegistrationCode && !eventData.registrationCode &&
                                <small className="text-danger">Please enter a registration code or disable the toggle to continue.</small>
                            }
                        </div>
                    </div>
                </ModalBody>
                {/*<ModalFooter>*/}
                {/*    <Button color="secondary" onClick={modalToggle}>*/}
                {/*        */}{/*<FontAwesomeIcon icon={faFloppyDisk} spin={false} className="me-2" />*/}
                {/*        Cancel*/}
                {/*    </Button>*/}
                {/*    <Button color="primary" onClick={modalToggle}>*/}
                {/*        <FontAwesomeIcon icon={faFloppyDisk} spin={false} className="me-2" />*/}
                {/*        Save*/}
                {/*    </Button>*/}
                {/*</ModalFooter>*/}
            </Modal>
        </>
    );
};
